import { render, staticRenderFns } from "./PublisherList.vue?vue&type=template&id=2c7b5518&scoped=true&"
import script from "./PublisherList.vue?vue&type=script&lang=js&"
export * from "./PublisherList.vue?vue&type=script&lang=js&"
import style0 from "./PublisherList.vue?vue&type=style&index=0&id=2c7b5518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b5518",
  null
  
)

export default component.exports